import React from "react"
import { FormattedMessage } from "react-intl"
import Integrations from "../../../integration/Integrations"
import { EventObjectDto } from "../../../state/event/Event"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { OrderDto } from "../../../state/order/Order"
import DocumentEventExportedComponent from "./DocumentEventExportedComponent"

type OwnProps = {
    object: EventObjectDto
    order: OrderDto
}

const OrderExportedToHubspotEvent = (props: OwnProps) => {
    const Url = Integrations.getExternalOrderUrl(props.object)

    return <DocumentEventExportedComponent 
        url={Url}
        exportedMainMessage={<FormattedMessage
            id="order.analytics.events.exported.hubspot.text"
            defaultMessage="Order {identifier} was created from a HubSpot deal"
            values={{
                identifier: <strong>{props.order.attributes.identifier}</strong>,
            }}
        />}
        buttonMessage={<FormattedMessage
            id="order.analytics.events.exported.hubspot.open"
            defaultMessage="Open deal in HubSpot"
        />}
        integrationLogo={{
            integrationKey: INTEGRATION_KEY.HUBSPOT,
            width: 100,
            height: 30,
        }}
    />
}


export default OrderExportedToHubspotEvent


// WEBPACK FOOTER //
// ./src/quote/analytics/events/order-exported-hubspot.component.tsx